export default "__VITE_ASSET__BCTojpTe__"